export const pricePerCredits = (credits: number): number => {
    switch (credits) {
        case 22:
            return 80;
        case 36:
            return 70;
        case 64:
            return 60;
        case 96:
            return 55;
        case 128:
            return 52;
        case 256:
            return 50;
        default:
            return 0;
    }
}